export default __webpack_public_path__ + "static/media/mrle-bar.41411a00.jpg";